import { useState } from "react";
import { nomenclaturaTotal } from "../helpers/checkDataInpustForms";
import { truncateNumber } from "../helpers/operationMath";

export const useProjectHrsDetails = (areasData = {}) => {
    const [simboleHrs, setSimboleHrs] = useState("");
    const [hrsPlanning, setHrsPlanning] = useState(0);
    const [inputsAreas, setInputsAreas] = useState([]);
    const [hrsDeveloping, setHrsDeveloping] = useState(0);
    const [hrsToDistribute, setHrsToDistribute] = useState(0);
    const [percentHrsTesting, setPercentHrsTesting] = useState(0);

    const getInputsAreas = (areas) => {
        let jsonForm = {
            web: 0,
            unity: 0,
            design: 0,
            art3d: 0,
        };
        let sumTotalBudgetArea = 0;
        const inputsArea = Object.entries(areas).map(([key, value]) => {
            jsonForm[areasData[key].name] = value;
            sumTotalBudgetArea += value;
            return {
                label: areasData[key].label,
                name: areasData[key].name,
                hrs: value,
            };
        });
        return {
            jsonForm,
            sumTotalBudgetArea,
            inputsArea,
        };
    };

    const getDevelopingVsDistribute = (developingTotal = 0, sumTotalArea = 0) => {
        return developingTotal - sumTotalArea;
    };

    const getPercentHrs = (percentTesting, developing) => {
        return (percentTesting * developing) / 100;
    };

    const getPercentTestingHrs = (testing, developing) => {
        return (testing * 100) / developing;
    };

    const getSimbole = (isTracing = false, sumTotalArea) => {
        const nomenclature = nomenclaturaTotal(sumTotalArea);
        return isTracing ? "F" : nomenclature;
    };

    const fillInData = (dataForm) => {
        const { developing, planning, isTracing, testing, ...areas } = dataForm;

        const { inputsArea, sumTotalBudgetArea, jsonForm } = getInputsAreas(areas);

        const developmentVsTotalBudget = getDevelopingVsDistribute(developing, sumTotalBudgetArea + testing);

        const percentTesting = getPercentTestingHrs(testing, developing);

        const nomenclature = getSimbole(isTracing, developing + planning);

        // truncateFloat

        setPercentHrsTesting(testing);
        setSimboleHrs(nomenclature);
        setHrsToDistribute(developmentVsTotalBudget);
        setInputsAreas(inputsArea);
        setHrsDeveloping(developing);
        setHrsPlanning(planning);

        return { ...jsonForm, percentTesting: truncateNumber(percentTesting), isTracing, hrsPlanning: planning, hrsDeveloping: developing };
    };

    const onFieldsChange = (_, allFields) => {
        const sumTotalArea = allFields.reduce((accumulator, { value, name }) => {
            if (["percentTesting", "isTracing", "hrsPlanning", "hrsDeveloping"].includes(name[0])) return accumulator;
            const valueTime = value || 0;
            return accumulator + valueTime;
        }, 0);

        const { value: valueIsTracing } = allFields.find((fields) => fields.name[0] === "isTracing");
        const { value: valueTesting } = allFields.find((fields) => fields.name[0] === "percentTesting");
        const nomenclature = getSimbole(valueIsTracing, hrsDeveloping + hrsPlanning);
        const percentHrs = getPercentHrs(valueTesting, hrsDeveloping);
        const developmentVsTotalBudget = getDevelopingVsDistribute(hrsDeveloping, sumTotalArea + percentHrs);

        setPercentHrsTesting(percentHrs);
        setSimboleHrs(nomenclature);
        setHrsToDistribute(developmentVsTotalBudget);
    };

    return {
        hrsDeveloping,
        hrsPlanning,
        hrsToDistribute,
        inputsAreas,
        simboleHrs,
        percentHrsTesting,
        fillInData,
        onFieldsChange,
    };
};
